<app-krk-add
  [ofwcaObject]="ofwcaObject"
  (krkCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-krk-add>
